(() => {
  if (customElements.get('slider-tiles')) {
    return;
  }

  class SliderTiles extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.swiper = new Swiper(this, {
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: 16,
        pagination: {
          el: "[data-pagination]"
        },
        navigation: {
          nextEl: this.querySelector('[data-next]'),
          prevEl: this.querySelector('[data-prev]')
        },
        breakpoints: {
          480: {
            slidesPerView: 2,
            slidesPerGroup: 2,
            spaceBetween: 24
          },
          1024: {
            slidesPerView: 4,
            slidesPerGroup: 2,
            spaceBetween: 24
          }
        }
      });
    }
  }

  customElements.define('slider-tiles', SliderTiles);
})();
